import { SocketIoChannel } from 'tradera-services/socket-io-channel';

let globalSocket = null;

export const getGlobalSocket = socketUrl => {
    if (!globalSocket) {
        globalSocket = new SocketIoChannel(socketUrl, true);
    }
    return globalSocket;
};
